import { benefitService } from "@crescentParts/Services/BenefitService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

export interface BenefitFormParameter{
    password:string;
    onSuccess: () => void;
    onError: (error: string) => void;
}

type HandlerType = Handler<BenefitFormParameter>;

export const Subscribe: HandlerType = async props => {
    const data = {
        password : props.parameter.password,
    };
    try {
       const result =  await benefitService({ benefitForm: data });
       
       if(result.successful){
        props.parameter.onSuccess();
       }
       else{
        props.parameter.onError(result?.errorMessage);
       }
       
    } catch (err) {
        
        props.parameter.onError(err?.errorMessage || err);
    }
};

export const chain = [Subscribe];

const submitBenefit = createHandlerChainRunner(chain, "Benefits");
export default submitBenefit;